// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"92":"5be59a80","236":"8e14f2e2","859":"37122cd1"}[chunkId] + ".css";
};